"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFormFieldFile = void 0;
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var AttachFile_1 = __importDefault(require("@material-ui/icons/AttachFile"));
var react_1 = __importStar(require("react"));
var useFilePicker_1 = require("../hooks/FilePicker/useFilePicker");
var APForm_1 = require("./APForm");
function APFormFieldFile(_a) {
    var _this = this;
    var style = _a.style, label = _a.label, placeholder = _a.placeholder, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, helperText = _a.helperText, onChanged = _a.onChanged, validator = _a.validator, control = _a.control, accept = _a.accept;
    var control2 = react_1.useContext(APForm_1.APFormContext);
    if (control !== undefined) {
        control2 = control;
    }
    var _c = useFilePicker_1.useFilePicker(), files = _c.files, onClick = _c.onClick, HiddenFileInput = _c.HiddenFileInput, reset = _c.reset;
    var file = null;
    if (files !== null && files.length > 0) {
        file = files[0];
    }
    var _d = react_1.useState(null), error = _d[0], setError = _d[1];
    function checkValues() {
        return __awaiter(this, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorMessage = null;
                        if (!validator) return [3 /*break*/, 2];
                        return [4 /*yield*/, validator(file)];
                    case 1:
                        errorMessage = _a.sent();
                        _a.label = 2;
                    case 2:
                        setError(errorMessage);
                        return [2 /*return*/, !errorMessage];
                }
            });
        });
    }
    var fieldItem = {
        validate: checkValues,
        reset: function () {
            reset();
        }
    };
    react_1.useEffect(function () {
        if (control2 !== undefined)
            control2.fields.add(fieldItem);
        return function () {
            if (control2 !== undefined)
                control2.fields.delete(fieldItem);
        };
    });
    react_1.useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(validator && error !== null)) return [3 /*break*/, 2];
                        _a = setError;
                        return [4 /*yield*/, validator(file)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        _b.label = 2;
                    case 2:
                        if (onChanged)
                            onChanged(file);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [file]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextField_1.default, { style: style, type: 'text', label: label, variant: 'outlined', 
            // size='small'
            color: 'primary', value: (file === null || file === void 0 ? void 0 : file.name) || '', helperText: error || helperText, error: !!error, margin: 'normal', onClick: onClick, multiline: true, InputProps: {
                readOnly: true,
                placeholder: placeholder,
                endAdornment: react_1.default.createElement(InputAdornment_1.default, { position: 'end' },
                    react_1.default.createElement(IconButton_1.default, { onClick: function () { }, size: 'small' },
                        react_1.default.createElement(AttachFile_1.default, null)))
            } }),
        react_1.default.createElement(HiddenFileInput, { accept: accept })));
}
exports.APFormFieldFile = APFormFieldFile;
